import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { TurnoverByBrokersReportFilter } from "../types";

export const getTradeByBrokersReport = (
  user: User,
  filter: TurnoverByBrokersReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getturnoverbybrokreport",
    params: {
      userid: user.userId,
      datefrom: filter.datefrom,
      dateto: filter.dateto,
      brokerId: filter?.brokerId,
      cliStatus: filter?.cliStatus,    
    },
  });
};

export default getTradeByBrokersReport;
